<div class="contents" ssTooltipRoot>
  <router-outlet></router-outlet>
</div>
